<template>
  <div class="row">
    <div class="col-md-12">
      <div>
        <p>Action: {{ capitalizedStr(record.action) }}</p>
        <template v-if="record.action === 'created' && record.details">
          <p v-for="(value, key) in record.details" :key="key">
            <template v-if="key === 'request_from'">
              {{ formatString(key) }} - {{ value }}
            </template>
          </p>
        </template>
        <template v-else>
          <p v-for="(value, key) in record.details" :key="key">
            {{ formatString(key) }} - {{ value }}
          </p>
        </template>
      </div>
      <div>
<!--        <pre>{{ record }}</pre>-->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AuditLogInfo',
  props: ['closeModal', 'loadData', 'record'],
  data() {
    return {
      lyLoading: false,
    }
  },
  created() {
  },
  methods: {
    capitalizedStr(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    formatString(value) {
      let formattedString = value.replace(/_/g, ' ');
      formattedString = formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
      return formattedString;
    }
  }
}
</script>
<style scoped>

</style>
  